<template>
  <at-alert v-if="error" type="danger" dismissible>
    <div class="flex flex-col gap-y-2">
      <span v-if="errorMessage" class="whitespace-normal">{{ errorMessage }}</span>

      <ul v-if="showValidationErrors && validationErrors" class="list-disc pl-5">
        <li v-for="(errorMessages, field) in validationErrors" :key="field">
          {{ field }}: {{ errorMessages.join(', ') }}
        </li>
      </ul>
    </div>
  </at-alert>
</template>

<script setup>
  import { computed, ref, watch } from 'vue';
  import { AtAlert } from '@packages/aliftech-ui';
  import { extractErrorMessage } from './utils';

  const props = defineProps({
    error: {
      type: [Object, String],
      default: null,
    },
    showValidationErrors: {
      type: Boolean,
      default: true,
    },
  });

  const errorMessage = ref(null);

  watch(
    () => props.error,
    async error => {
      if (error) {
        errorMessage.value = await extractErrorMessage(error);
      } else {
        errorMessage.value = null;
      }
    },
    {
      immediate: true,
    }
  );

  const validationErrors = computed(() => {
    return props.error?.response.data.errors;
  });
</script>
